import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const forYou = ['Querés bajar de peso sin rutinas agotadoras ni gimnasios', 'Tenés poco tiempo y necesitás algo que puedas hacer todos los días', 'Querés empezar desde cero sin experiencia previa', 'Buscás un cambio de hábitos real y sostenible en el tiempo', 'Ya caminás pero querés hacerlo con método y ver resultados', 'Sos mamá, trabajador/a, estudiante o ama de casa con agenda ocupada'];
const notForYou = ['Buscás resultados mágicos sin ningún tipo de esfuerzo', 'Esperás bajar 10 kilos en 7 días', 'No estás dispuesto/a a dedicar al menos 30 minutos por día', 'Solo querés teoría sin aplicarla en tu vida real', 'Ya sos atleta de alto rendimiento con entrenamiento avanzado', 'Preferís métodos extremos o muy intensos'];
export function ForYou() {
  return <section className="w-full bg-cream" data-id="element-81" data-mp="21a6xpazkjwo9">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-24" data-id="element-82" data-mp="21b8kgcpy67lt">
        <Reveal className="text-center" data-id="element-83" data-mp="3488nt25icctl">
          <h2 className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-84" data-mp="349jupau920ox">¿Es para mí?</h2>
          <p className="mt-4 text-lg text-ink/70" data-id="element-85" data-mp="397tn5dolan6u">Este programa es para vos si…</p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-86" data-mp="3e5d62qw8fo54">
          <Reveal data-id="element-87" data-mp="3ix4wn1fe1tv9">
            <div className="h-full rounded-2xl border border-brand/30 bg-white p-7" data-id="element-88" data-mp="3ixn28onxxkfu">
              <h3 className="flex items-center gap-2 text-lg font-bold text-brand-dark" data-id="element-89" data-mp="3nwpybjly0gbo">
                <CheckIcon className="h-5 w-5" data-id="element-90" data-mp="3rwrz7qjut5pw" /> Es para vos
              </h3>
              <ul className="mt-5 space-y-4" data-id="element-91" data-mp="ri45kh0619f">
                {forYou.map(t => <li key={t} className="flex items-start gap-3 text-sm leading-relaxed text-ink/80" data-id="element-92" data-mp="pfifcmvuuai">
                    <CheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brand" data-id="element-93" data-mp="22ilgce6jjnw3" />
                    {t}
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-94" data-mp="1zh0izy22ks90">
            <div className="h-full rounded-2xl border border-ink/10 bg-white p-7" data-id="element-95" data-mp="1zg8o6pgaqyjs">
              <h3 className="flex items-center gap-2 text-lg font-bold text-ink/60" data-id="element-96" data-mp="1vfx1z88acq67">
                <XIcon className="h-5 w-5" data-id="element-97" data-mp="29ewr0gzpn72w" /> No es para vos
              </h3>
              <ul className="mt-5 space-y-4" data-id="element-98" data-mp="29d3l53wx8qvy">
                {notForYou.map(t => <li key={t} className="flex items-start gap-3 text-sm leading-relaxed text-ink/60" data-id="element-99" data-mp="24esbat6mmgdq">
                    <XIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-ink/30" data-id="element-100" data-mp="2idrxlu6o2j6q" />
                    {t}
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}